import { useMemo } from 'react';
import { useLocation } from 'react-router';

export const useTabBarVisibility = () => {
  const location = useLocation();
  // TODO: Update path check when account & payment pages are merged
  const isTabBarVisible = useMemo(
    () =>
      !location?.pathname.match('/games/launch') &&
      !location?.pathname.includes('/register') && // ????
      !location?.pathname.match('/payment-launch/') &&
      !location?.pathname.match('/account/payment-result') &&
      !location?.pathname.includes('/payment-result') &&
      !location?.pathname.includes('/payment-result-iframe') &&
      !location?.pathname.includes('/account/verify') &&
      !location?.pathname.includes('/interac-redirect') &&
      !location?.pathname.includes('/prize-wall'),
    [location.pathname],
  );
  return isTabBarVisible;
};
